import { clerkPlugin } from "@clerk/vue"
import { ptBR } from "@clerk/localizations"

export default defineNuxtPlugin({
  name: "clerk",
  setup(nuxtApp) {
    const config = useRuntimeConfig()
    const publishableKey = config.public.NUXT_PUBLIC_CLERK_PUBLISHABLE_KEY

    if (!publishableKey) {
      console.warn("[Clerk] NUXT_PUBLIC_CLERK_PUBLISHABLE_KEY não configurada.")
      return
    }


    nuxtApp.vueApp.use(clerkPlugin, {
      publishableKey,
      localization: ptBR,
      signInUrl: "/login",
      signUpUrl: "/auth/criar-conta",
      signInForceRedirectUrl: "/perfil",
      signUpForceRedirectUrl: "/perfil",
    })
  },
})
